<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="saleOrderProducts"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="hasTableTitle"
    :tableTitle="tableTitle"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :modelNameSingular="modelNameSingular"
        :extras="extras"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
        :extras="extras"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
        :extras="extras"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :modelNameSingular="modelNameSingular"
      />
    </template>


    <template slot="tableFooter" v-if="extras.accountContext.accountPermissions.isAltavenda">
      <tr class="d-none d-md-table-row">
        <td colspan="5"><strong class="title">Total dos Produtos</strong></td>
        <td colspan="2" class="text-xs-right title"><strong>{{ this.saleTotalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total dos Produtos</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.saleTotalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>

    <template slot="tableFooter" v-else>
      <tr class="d-none d-md-table-row">
        <td colspan="5"><strong class="title">Total dos Produtos</strong></td>
        <td colspan="2" class="text-xs-right title"><strong>{{ this.saleTotalPrice | formatCurrency }}</strong></td>
      </tr>

      <!-- for mobile only -->
      <tr class="d-table-row d-md-none v-data-table__mobile-table-row">
        <td class="v-data-table__mobile-row">
          <div class="v-data-table__mobile-row__header">Total dos Produtos</div>
          <div class="v-data-table__mobile-row__cell"><strong>{{ this.saleTotalPrice | formatCurrency }}</strong></div>
        </td>
      </tr>
    </template>



  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      tableHeaders: [
        { text: "Produto", align: "left", sortable: true, value: "item.name" },
        { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
        { text: "Depósito", align: "left", sortable: true, value: "storage.name" },
        { text: "R$", align: "left", sortable: true, value: "packagingPrice" },
        { text: "Qtd.", align: "left", sortable: true, value: "packagingQuantity" },
        // { text: "Und.", align: "left", sortable: true, value: "packagingUnitName" },
        { text: "R$ Total", align: "left", sortable: true, value: "price" },
        // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'unitPrice', mask: 'currency_10d'},
        { field: 'packagingPrice', mask: 'currency_10d'},
        { field: 'discount', mask: 'currency_10d'},
        { field: 'totalDiscount', mask: 'currency_10d'},
        { field: 'liquidPrice', mask: 'currency_10d'},
        { field: 'quantity', mask: 'number'},
        { field: 'price', mask: 'currency'}
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    extras: {
      type: Object,
      default: null,
    },
    saleOrderProducts: {
      type: Array,
      default: []
    },
    saleTotalPrice: {
      type: Number,
      default: 0
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    hasTableTitle: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String
    },
    modelNameSingular: {
      type: String,
      default: "Produto de Pedido de Venda"
    },
    modelNamePlural: {
      type: String,
      default: "Produtos de Pedido de Venda"
    },
  },
  mounted(){
    // console.log("mounted", this.extras);
    if(this.extras.accountContext.accountPermissions.isAltavenda){
      this.tableHeaders = [{ text: "Produto", align: "left", sortable: true, value: "item.name" },
          { text: "Embalagem", align: "left", sortable: true, value: "packaging.name" },
          { text: "Depósito", align: "left", sortable: true, value: "storage.name" },
          { text: "R$", align: "left", sortable: true, value: "packagingPrice" },
          { text: "Qtd.", align: "left", sortable: true, value: "packagingQuantity" },
          { text: "R$ Total", align: "left", sortable: true, value: "price" },
          { text: "Desc.", align: "left", sortable: true, value: "discount" },
          { text: "Desc. Total", align: "left", sortable: true, value: "totalDiscount" },
          { text: "R$ Total Liq.", align: "left", sortable: true, value: "liquidPrice" },
          // { text: "deleted", value: "_destroy", align: ' d-none', sortable: false, filter: value => value ? !value : true },
          { text: "Ações", value: "action", sortable: false }];
    }

  },
  created() {
    // console.log("index", this.saleOrderProducts);
  },
  methods: {
    entryUpdated: function(editedSaleProduct){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
      this.recalculateSaleTotalPrice();
    },
    entryCreated: function(newSaleProduct){
      this.saleOrderProducts.push(newSaleProduct);
      this.$refs.baseIndex.showConfirmationCreateMessage();
      this.recalculateSaleTotalPrice();
    },
    entryDeleted: function(deletedSaleProduct){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
      this.recalculateSaleTotalPrice();
    },
    recalculateSaleTotalPrice: function() {
      var newSaleTotalPrice = 0;
      for (var sale in this.saleOrderProducts) {
        if(!this.saleOrderProducts[sale]._destroy) {
          newSaleTotalPrice += this.saleOrderProducts[sale].price;
        }
      }
      newSaleTotalPrice = _.round(newSaleTotalPrice, 2);
      this.$emit('update:saleTotalPrice', newSaleTotalPrice);
    }
  }
};
</script>

<style scoped></style>
